<template>
  <slot v-if="loaded" />
</template>
<script>
import NetteAjax from "../nette/NetteAjax";

export default {
  props: {
    url: {
      type: String,
    }
  },
  data () {
    return {
      loaded: false,
    }
  },
  mounted () {
    NetteAjax.ajax({
      url: this.url,
      off: ['unique'],
      onSuccess: () => {
        this.loaded = true
      }
    })
  }
}
</script>